"use client";
import React from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import Link from "next/link";
export default function SizeChanger(props) {
  let machine = props.data;
  return (
    <div className="size-changer">
      <h4>Change Model</h4>
      <div className="button-wrapper">
        {machine.go_smaller !== "null" ? (
          <Link href={`/models/${String(machine.go_smaller).toLowerCase()}`}>
            <div className="button-div smaller">
              <div className="icon">
                <HiChevronLeft />
              </div>
              <div>
                <h5>Go Smaller</h5>
                <h5 className="scrubber-name">{machine.go_smaller}</h5>
              </div>
            </div>
          </Link>
        ) : (
          <div className="button-div smaller">
            <div className="icon">
              <HiChevronLeft />
            </div>
            <div>
              <h5>Smallest</h5>
              <h5 className="scrubber-name">Cant Go Smaller</h5>
            </div>
          </div>
        )}
        {machine.go_bigger !== "null" ? (
          <Link href={`/models/${machine.go_bigger.toLowerCase()}`}>
            <div className="button-div">
              <div>
                <h5>Go Bigger</h5>
                <h5 className="scrubber-name">{machine.go_bigger}</h5>
              </div>
              <div className="icon">
                <HiChevronRight />
              </div>
            </div>
          </Link>
        ) : (
          <div className="button-div">
            <div>
              <h5>Biggest</h5>
              <h5 className="scrubber-name">Cant Go Bigger</h5>
            </div>
            <div className="icon">
              <HiChevronRight />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
